import type { ScrollToBottom } from 'use-stick-to-bottom';
import { Collapsible } from '~/components/ui/Collapsible';
import { ShellCodeBlock } from '~/components/ui/ShellCodeBlock';
import { Terminal } from '~/components/workbench/terminal/Terminal';
import type { PotentialShellProblem } from '~/types/chat';

interface ShellRendererProps extends PotentialShellProblem {
  scrollToBottom?: ScrollToBottom;
}

export function ShellRenderer({ scrollToBottom, ...error }: ShellRendererProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <div className="text-lg i-ph:x text-bolt-elements-icon-error"></div>
        Command failed
      </div>
      <Collapsible
        defaultOpen={false}
        titleClassName="flex-col"
        toggleButtonClassName="bg-[var(--bolt-elements-actions-code-background)]"
        scrollToBottom={scrollToBottom}
        title={<ShellCodeBlock className="[&>pre]:px-4 [&>pre]:py-5" code={error.command} />}
      >
        <Terminal className="grow-1 h-[150px]" readonly>
          {error.output.trim()}
        </Terminal>
      </Collapsible>
    </div>
  );
}
